import React from 'react';
import Select from 'react-select-v1';

import 'react-select-v1/dist/react-select.css';
// react-select customization
import './Select.scss';

const SelectComponent = props => <Select {...props} />;

export default SelectComponent;
